import React, { useState, useEffect } from 'react'

const CountdownTimer = ({ initialSeconds }) => {
  const [seconds, setSeconds] = useState(initialSeconds)

  useEffect(() => {
    try {
      if (seconds > 0) {
        const timerId = setInterval(() => {
          setSeconds((prevSeconds) => prevSeconds - 1)
        }, 1000)
        return () => clearInterval(timerId)
      }
    } catch (e) {
      console.log(e)
    }
  }, [seconds])

  const formatTime = (seconds) => {
    try {
      const minutes = Math.floor(seconds / 60)
      const remainingSeconds = seconds % 60
      return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`
    } catch (e) {
      console.log(e)
    }
  }

  return (
    <div className="flex justify-center items-center">
      <div className="text-4xl p-4">{formatTime(seconds)}</div>
    </div>
  )
}

export default CountdownTimer
